var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCostsTermNotice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Costs_Term_Notice"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Costs_Term_Notice",
    "data-name": "Costs, Term Notice",
    clipPath: "url(#clip-Costs_Term_Notice)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11782",
    "data-name": "Group 11782",
    transform: "translate(1.347 0.657)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11783",
    "data-name": "Group 11783"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22232",
    "data-name": "Path 22232",
    d: "M6.028,0a2.554,2.554,0,0,1,.644.316,1.5,1.5,0,0,1,.527.8.139.139,0,0,0,.166.127c.309-.006.619,0,.929,0a.756.756,0,0,1,.79.8c-.006.176.048.212.212.21.6-.009,1.194,0,1.792,0,.266,0,.384.108.385.368,0,.532,0,1.064,0,1.6a.313.313,0,0,1-.321.348.323.323,0,0,1-.331-.359c0-.38-.006-.76,0-1.14,0-.124-.024-.169-.158-.167-.478.009-.956.008-1.433,0-.114,0-.153.03-.144.144a.768.768,0,0,1-.248.644.779.779,0,0,1-.565.208c-1.689,0-3.377,0-5.066,0a.765.765,0,0,1-.8-.8c.02-.175-.055-.2-.21-.2-.45.01-.9.011-1.352,0-.151,0-.176.047-.176.183q.006,5.034,0,10.069c0,.907,0,1.814,0,2.721,0,.136.038.17.172.17q3.926-.006,7.852,0A.222.222,0,0,0,8.864,16a4.226,4.226,0,0,1-1.828-2.944A4.168,4.168,0,0,1,10.3,8.472a1.191,1.191,0,0,1,.317-.057c.188.015.21-.073.206-.229-.009-.347,0-.695,0-1.043a.329.329,0,0,1,.327-.364.314.314,0,0,1,.325.346c.005.375,0,.749,0,1.124,0,.091.008.148.125.162a4.065,4.065,0,0,1,2.934,1.722,3.974,3.974,0,0,1,.77,2.532,4.164,4.164,0,0,1-3.335,3.946,3.322,3.322,0,0,1-.693.074q-5.433,0-10.865,0A.4.4,0,0,1,0,16.392V2.476a.514.514,0,0,1,.508-.233c.558.014,1.117,0,1.675.005.22,0,.232,0,.223-.225a.774.774,0,0,1,.806-.787c.308.013.618,0,.927,0,.078,0,.117-.008.141-.1A1.527,1.527,0,0,1,4.688.429,1.967,1.967,0,0,1,5.474,0ZM11.16,9.04a3.541,3.541,0,0,0-3.505,3.449A3.493,3.493,0,1,0,11.16,9.04M5.753,3.229H8.212c.2,0,.218-.014.22-.223,0-.288,0-.575,0-.863,0-.223-.017-.243-.239-.243-.407,0-.814,0-1.221,0a.348.348,0,0,1-.386-.381,1.075,1.075,0,0,0-.021-.225A.839.839,0,0,0,5.7.656a.855.855,0,0,0-.8.848c-.018.3-.119.4-.427.4-.4,0-.8,0-1.2-.005-.143,0-.206.043-.2.2.01.293,0,.586,0,.879,0,.255,0,.256.248.256H5.753",
    transform: "translate(0 0.001)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22233",
    "data-name": "Path 22233",
    d: "M26.024,54.944h2.962a.347.347,0,0,1,.336.185.3.3,0,0,1-.017.322.276.276,0,0,1-.223.142c-.1.005-.195.009-.292.009h-5.68c-.274,0-.418-.107-.425-.315a.324.324,0,0,1,.361-.344c.586,0,1.172,0,1.758,0h1.221",
    transform: "translate(-20.208 -48.945)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22234",
    "data-name": "Path 22234",
    d: "M25.263,77.4q-1.1,0-2.2,0c-.236,0-.371-.116-.374-.312a.326.326,0,0,1,.364-.344c.537,0,1.075,0,1.612,0h2.784c.237,0,.377.11.389.3a.312.312,0,0,1-.33.356c-.228.006-.456,0-.684,0H25.263Z",
    transform: "translate(-20.213 -68.365)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22235",
    "data-name": "Path 22235",
    d: "M24.493,121c-.477,0-.954,0-1.431,0-.226,0-.364-.116-.375-.3a.338.338,0,0,1,.378-.365c.651,0,1.3,0,1.952,0h.911c.257,0,.408.126.408.336s-.143.331-.411.332c-.477,0-.954,0-1.431,0Z",
    transform: "translate(-20.209 -107.195)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22236",
    "data-name": "Path 22236",
    d: "M24.527,98.525c.483,0,.965,0,1.448,0a.333.333,0,0,1,.339.205.316.316,0,0,1-.069.36.358.358,0,0,1-.267.1c-.982,0-1.963,0-2.945-.005a.314.314,0,0,1-.347-.327.328.328,0,0,1,.36-.333c.493,0,.987,0,1.481,0Z",
    transform: "translate(-20.209 -87.767)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22237",
    "data-name": "Path 22237",
    d: "M99.764,49.141a.322.322,0,0,1-.327.329.344.344,0,0,1-.322-.343.335.335,0,0,1,.326-.32.324.324,0,0,1,.323.333",
    transform: "translate(-88.294 -43.479)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22238",
    "data-name": "Path 22238",
    d: "M90.2,93c0-.239,0-.478,0-.716a.169.169,0,0,0-.115-.185,1.53,1.53,0,0,1-.682-.508,1.218,1.218,0,0,1,.636-1.8c.1-.035.164-.058.165-.189a.323.323,0,0,1,.645,0,.144.144,0,0,0,.134.148,1.394,1.394,0,0,1,.555.257.342.342,0,0,1,.1.483.334.334,0,0,1-.5.046c-.079-.058-.178-.147-.255-.112s-.029.165-.03.253c0,.3,0,.6,0,.9a.164.164,0,0,0,.133.187,1.465,1.465,0,0,1,.742.474,1.441,1.441,0,0,1-.7,2.2c-.12.042-.183.083-.18.228a.313.313,0,0,1-.325.33.33.33,0,0,1-.325-.338c0-.11-.029-.142-.143-.153a1.739,1.739,0,0,1-.816-.335.328.328,0,0,1,.362-.546,2.04,2.04,0,0,0,.436.211c.118.034.164.025.158-.115-.011-.238,0-.478,0-.716Zm.66.076h0c0,.119-.006.239,0,.358s-.058.279.044.31.206-.116.28-.213a.688.688,0,0,0-.205-1.057c-.112-.057-.127-.022-.124.081,0,.174,0,.347,0,.521M90.2,91.421c0-.308,0-.592,0-.877,0-.1-.048-.078-.1-.037a.571.571,0,0,0-.228.5.522.522,0,0,0,.326.418",
    transform: "translate(-79.38 -79.555)",
    fill: "#0072ce"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostsTermNotice);
export default __webpack_public_path__ + "static/media/Costs, Term Notice.831e155edb1db1cdbea67747febd1142.svg";
export { ForwardRef as ReactComponent };